import { Table, TableContainer, alpha } from "@mui/material";
import { ReactNode } from "react";

type CompactTableContainerProps = {
  children: ReactNode;
  /** Zebra striping nas linhas — usado por widgets de dashboard, não por listagens de página cheia. */
  zebra?: boolean;
  stickyHeader?: boolean;
  maxHeight?: number | string;
};

/**
 * Variante compacta do padrão de tabela (mesma cor/tipografia/hover do tema global,
 * densidade reduzida) para tabelas embutidas em diálogos, cards e widgets de dashboard.
 */
export function CompactTableContainer({
  children,
  zebra = false,
  stickyHeader = false,
  maxHeight,
}: CompactTableContainerProps) {
  return (
    <TableContainer sx={maxHeight ? { maxHeight } : undefined}>
      <Table
        size="small"
        stickyHeader={stickyHeader}
        sx={
          zebra
            ? {
                "& tbody tr:nth-of-type(even)": {
                  backgroundColor: (theme) => alpha(theme.palette.action.hover, 0.3),
                },
              }
            : undefined
        }
      >
        {children}
      </Table>
    </TableContainer>
  );
}

export default CompactTableContainer;
